import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../api";
import useShowToast from "../../../hooks/useShowToast";

/**
 * Custom hook to delete users.
 * @returns Object containing the deleteUsers function and loading state
 */
function useDeleteUsers() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { successToast, errorToast } = useShowToast();

  const deleteUsers = async (selectedUserIds: number[]) => {
    setIsLoading(true);
    try {
      await api.bulkDeleteUsers({
        user_ids: selectedUserIds,
      });
      if (api?.error) {
        errorToast({
          title: t("club_management.users.delete_users.error_title"),
          description: api.error?.data as string,
        });
        return;
      }
      successToast({
        title: t("club_management.users.delete_users.success_title"),
        description: t("club_management.users.delete_users.success_description", {
          count: selectedUserIds.length,
        }),
      });
    } catch (error) {
      errorToast({
        title: t("club_management.users.delete_users.error_title"),
        description: t("club_management.users.delete_users.error_description"),
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    deleteUsers,
    isLoading,
  };
}

export default useDeleteUsers;
